export const ASSET_CREATING_TITLES = {
  DESCRIPTION: "ENTER A DESCRIPTION",
  BRIEF: "USE A BRIEF",
  CONCEPT: "USE A CONCEPT",
};

export const CREATE_ASSETS_VALUES = {
  VIDEO_SCRIPT: " script",
  VIDEO_SCRIPT_IMAGES: "script and image",
  PRODUCT_PLACEMENT_TEXT: "product placement",
  FULLY_GENERATED_IMAGE: "fully generated",
};

export const BRIEF_INPUT_CONSTANT = (hasUniversalAccess?: boolean) => ({
  TITLE: "SELECT PROJECT OPTIONS",
  DESCRIPTION: "There are a few ways that you can get started creating content. Select one of the options below and let the magic begin. ",
  NEW_YEAR_PROMOTION: "OREO NEW YEAR PROMOTION",
  ASSET_CREATING_TYPE_LABEL: "How do you want to start creating assets?",
  ASSET_CREATING_TYPE: [
    { title: ASSET_CREATING_TITLES.DESCRIPTION, description: "Tell us a little bit about what kind of assets you want to generate." },
    { title: ASSET_CREATING_TITLES.BRIEF, description: "Make adjustments to a current brief and create assets for your target audiences." },
    {
      title: ASSET_CREATING_TITLES.CONCEPT,
      description: "Have a concept already? Quickly create assets for your target audiences.",
      hide: hasUniversalAccess,
    },
  ],

  CONCEPT_OPTIONS_LABEL: "Select one concept to use as a reference",
  CONCEPT_OPTIONS: [
    {
      id: "Milka Holiday concept (created 09232024)",
      label: "Milka Holiday concept (created 09232024)",
    },
    {
      id: "Milka Ski concept  (created 08122024)",
      label: "Milka Ski concept  (created 08122024)",
    },
    {
      id: "Milka Mountain concept  (created 08062024)",
      label: "Milka Mountain concept  (created 08062024)",
    },
    {
      id: "Milka Movies concept  (created 08012024)",
      label: "Milka Movies concept  (created 08012024)",
    },
    {
      id: "Milka Outdoors concept (created 07102024)",
      label: "Milka Outdoors concept (created 07102024)",
    },
    {
      id: "Milka Holiday concept (created 09232024)",
      label: "Milka Holiday concept (created 09232024)",
    },
    {
      id: "Milka Ski concept  (created 08122024)",
      label: "Milka Ski concept  (created 08122024)",
    },
    {
      id: "Milka Mountain concept  (created 08062024)",
      label: "Milka Mountain concept  (created 08062024)",
    },
    {
      id: "Milka Movies concept  (created 08012024)",
      label: "Milka Movies concept  (created 08012024)",
    },
    {
      id: "Milka Outdoors concept (created 07102024)",
      label: "Milka Outdoors concept (created 07102024)",
    },
    {
      id: "Milka Holiday concept (created 09232024)",
      label: "Milka Holiday concept (created 09232024)",
    },
    {
      id: "Milka Ski concept  (created 08122024)",
      label: "Milka Ski concept  (created 08122024)",
    },
    {
      id: "Milka Mountain concept  (created 08062024)",
      label: "Milka Mountain concept  (created 08062024)",
    },
    {
      id: "Milka Movies concept  (created 08012024)",
      label: "Milka Movies concept  (created 08012024)",
    },
    {
      id: "Milka Outdoors concept (created 07102024)",
      label: "Milka Outdoors concept (created 07102024)",
    },
    {
      id: "Milka Holiday concept (created 09232024)",
      label: "Milka Holiday concept (created 09232024)",
    },
    {
      id: "Milka Ski concept  (created 08122024)",
      label: "Milka Ski concept  (created 08122024)",
    },
    {
      id: "Milka Mountain concept  (created 08062024)",
      label: "Milka Mountain concept  (created 08062024)",
    },
    {
      id: "Milka Movies concept  (created 08012024)",
      label: "Milka Movies concept  (created 08012024)",
    },
    {
      id: "Milka Outdoors concept (created 07102024)",
      label: "Milka Outdoors concept (created 07102024)",
    },
    {
      id: "Milka Holiday concept (created 09232024)",
      label: "Milka Holiday concept (created 09232024)",
    },
    {
      id: "Milka Ski concept  (created 08122024)",
      label: "Milka Ski concept  (created 08122024)",
    },
    {
      id: "Milka Mountain concept  (created 08062024)",
      label: "Milka Mountain concept  (created 08062024)",
    },
    {
      id: "Milka Movies concept  (created 08012024)",
      label: "Milka Movies concept  (created 08012024)",
    },
    {
      id: "Milka Outdoors concept (created 07102024)",
      label: "Milka Outdoors concept (created 07102024)",
    },
  ],
  CONCEPT_OPTIONS_DO_NOT_SEE: "Don’t see the concept you need?",
  CONCEPT_OPTIONS_SAVED_PROJECT: "View all Saved Projects",
  SETTINGS: "Settings",
  INPUT_SELECTION_ERROR_MESSAGE: "Please choose how you want to start creating assets.",
  SELECT_PROJECT: "Select Project",
  SELECT_CONCEPT: "Select and Generate",
});

export const BUTTON_TEXT = "Edit";
export const CreateAssetLabel = "CREATE ASSET";
export const EXPLORE_ERROR_ID = "exploreError";
